// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { xBaseTheme } from "@rc/XDL/types";

import DatePickerPresentationPropsDefault from "@insite/mobius/DatePicker/presentationProps";
import { color } from "@rc/XDL/Utilities";
import { css } from "styled-components";

export const chevronRightString =
    "PCEtLSBYTkdBR0UgQ09ORklERU5USUFMIC0tPg0KPCEtLSBfX19fX19fX19fX19fX19fX19fX19fX19fXyAtLT4NCjwhLS0gLS0+DQo8IS0tIENvcHlyaWdodCAoQykgMjAyMiBYbmdhZ2UgLSBBbGwgUmlnaHRzIFJlc2VydmVkIC0tPg0KPCEtLSAtLT4NCjwhLS0gQWxsIGNvZGUgb3IgaW5mb3JtYXRpb24gY29udGFpbmVkIGhlcmVpbiBpcywgYW5kIHJlbWFpbnMgdGhlIC0tPg0KPCEtLSBwcm9wZXJ0eSBvZiBYbmdhZ2UgTExDIGFuZCBpdHMgY3VzdG9tZXJzLiAgVGhlIGludGVsbGVjdHVhbCAtLT4NCjwhLS0gYW5kIHRlY2huaWNhbCBjb25jZXB0cyBjb250YWluZWQgYXJlIHByb3ByaWV0YXJ5IHRvIFhuZ2FnZSBMTEMgLS0+DQo8IS0tIGFuZCBtYXkgYmUgY292ZXJlZCBieSBVLlMuIGFuZCBGb3JlaWduIFBhdGVudHMsIHBhdGVudHMgaW4gLS0+DQo8IS0tIHByb2Nlc3MsIGFuZCBhcmUgcHJvdGVjdGVkIGJ5IHRyYWRlIHNlY3JldCBvciBjb3B5cmlnaHQgbGF3LiAtLT4NCjwhLS0gRGlzc2VtaW5hdGlvbiBvZiB0aGlzIGluZm9ybWF0aW9uIG9yIHJlcHJvZHVjdGlvbiBvZiB0aGlzIG1hdGVyaWFsIC0tPg0KPCEtLSBpcyBzdHJpY3RseSBmb3JiaWRkZW4gdW5sZXNzIHByaW9yIHdyaXR0ZW4gcGVybWlzc2lvbiBpcyBvYnRhaW5lZCAtLT4NCjwhLS0gZnJvbSBYbmdhZ2UgTExDLiAtLT4NCjwhLS0gLS0+DQoNCjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgNDAgMjQiIHhtbDpzcGFjZT0icHJlc2VydmUiPjxwYXRoIGZpbGw9IiNGRkZGRkYiIGQ9Im0yNy41IDAtMi4zIDIuMyA4LjA3IDguMDdIMHYzLjI2aDMzLjI3TDI1LjIgMjEuN2wyLjMgMi4zIDEyLTEyeiIvPjwvc3ZnPg==";

export const chevronLeftString =
    "PCEtLSBYTkdBR0UgQ09ORklERU5USUFMIC0tPg0KPCEtLSBfX19fX19fX19fX19fX19fX19fX19fX19fXyAtLT4NCjwhLS0gLS0+DQo8IS0tIENvcHlyaWdodCAoQykgMjAyMiBYbmdhZ2UgLSBBbGwgUmlnaHRzIFJlc2VydmVkIC0tPg0KPCEtLSAtLT4NCjwhLS0gQWxsIGNvZGUgb3IgaW5mb3JtYXRpb24gY29udGFpbmVkIGhlcmVpbiBpcywgYW5kIHJlbWFpbnMgdGhlIC0tPg0KPCEtLSBwcm9wZXJ0eSBvZiBYbmdhZ2UgTExDIGFuZCBpdHMgY3VzdG9tZXJzLiAgVGhlIGludGVsbGVjdHVhbCAtLT4NCjwhLS0gYW5kIHRlY2huaWNhbCBjb25jZXB0cyBjb250YWluZWQgYXJlIHByb3ByaWV0YXJ5IHRvIFhuZ2FnZSBMTEMgLS0+DQo8IS0tIGFuZCBtYXkgYmUgY292ZXJlZCBieSBVLlMuIGFuZCBGb3JlaWduIFBhdGVudHMsIHBhdGVudHMgaW4gLS0+DQo8IS0tIHByb2Nlc3MsIGFuZCBhcmUgcHJvdGVjdGVkIGJ5IHRyYWRlIHNlY3JldCBvciBjb3B5cmlnaHQgbGF3LiAtLT4NCjwhLS0gRGlzc2VtaW5hdGlvbiBvZiB0aGlzIGluZm9ybWF0aW9uIG9yIHJlcHJvZHVjdGlvbiBvZiB0aGlzIG1hdGVyaWFsIC0tPg0KPCEtLSBpcyBzdHJpY3RseSBmb3JiaWRkZW4gdW5sZXNzIHByaW9yIHdyaXR0ZW4gcGVybWlzc2lvbiBpcyBvYnRhaW5lZCAtLT4NCjwhLS0gZnJvbSBYbmdhZ2UgTExDLiAtLT4NCjwhLS0gLS0+DQoNCjxzdmcgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB2aWV3Qm94PSIwIDAgNDAgMjQiIHhtbDpzcGFjZT0icHJlc2VydmUiPjxwYXRoIGZpbGw9IiNGRkZGRkYiIGQ9Ik0zOS41IDEwLjM3SDYuMjNMMTQuMyAyLjMgMTIgMCAwIDEybDEyIDEyIDIuMy0yLjMtOC4wNy04LjA3SDM5LjV6Ii8+PC9zdmc+";

const arrowIcons = css`
    &__next-button {
        background-image: url("${`data:image/svg+xml;base64,${chevronRightString}`}");
    }
    &__prev-button {
        background-image: url("${`data:image/svg+xml;base64,${chevronLeftString}`}");
    }
`;

export default {
    defaultProps: {
        ...DatePickerPresentationPropsDefault,
        dateTimePickerProps: {
            showNeighboringMonth: true,
        },
        cssOverrides: {
            datePicker: css`
                button:focus {
                    span {
                    }
                }

                .react-calendar {
                    button {
                        &:enabled {
                            &:hover:not(:disabled),
                            &:focus:not(:disabled) {
                            }
                        }
                    }

                    &__navigation {


                        button {
                            &:enabled {
                                &:hover:not(:disabled),
                                &:focus:not(:disabled) {
                                }
                            }
                        }
                        &__label {
                        }
                        &__arrow {
                        }
                    }

                    &__month-view {
                        &__weekdays {
                        }

                        &__days {

                            &__day {
                            }
                        }
                    }
                }
            `,
        },
        placeholders: {
            dayPlaceholder: "DD",
            monthPlaceholder: "MM",
            yearPlaceholder: "YYYY",
            hourPlaceholder: "hr",
            minutePlaceholder: "min",
        },    
    },
} as xBaseTheme["datePicker"];
